import {gql} from 'apollo-angular';

export const UPDATE_BOOKMARK = gql`
  query UpdateBookmark($code: String!, $value: String!) {
    bookmarkUpdate(code: $code, storedValue: $value) {
      accessToken
    }
  }
`;
